import { WebSocketReceiveMessage } from './web-socket-receive-message';
import { Asset } from '../../../image/dto/asset';
import { GenerateUploadUrlRequest } from '../../../image/requests/generate-upload-url-request';

export class WebSocketAssetUploaded extends WebSocketReceiveMessage {
  override payload: Asset;

  override onDeserialize() {
    super.onDeserialize();
    this.payload = window?.injector?.Deserialize?.instanceOf(Asset, this.payload);
  }

  isFor(req: GenerateUploadUrlRequest): boolean {
    return this.payload?.fileName?.trim()?.toLowerCase() === req?.fileName?.trim()?.toLowerCase();
  }
}
